class CustomerAddress extends HTMLElement
{
    constructor()
    {
        super();

        this.actionButtons = this.querySelectorAll('[data-action]');

        this.actionButtons?.forEach(e => {
            e.addEventListener('click', this.actionClick.bind(this), false);
        });

        this.editDialog = this.querySelector('dialog');
    }

    actionClick(e)
    {
        if(e.target.dataset.action == 'delete')
        {
            if(confirm('Are you sure you wish to delete this address?'))
            {
                fetch(e.target.dataset.url, {
                    method: 'DELETE'
                });

                this.remove();
            }
        }

        if(e.target.dataset.action == 'edit' && this.editDialog)
        {
            this.editDialog.showModal();

            if(Shopify?.CountryProvinceSelector)
            {
                new Shopify.CountryProvinceSelector(
                    `address_country_${e.target.dataset.id}`, 
                    `address_province_${e.target.dataset.id}`, 
                    {
                        hideElement: `address_province_wrapper_${e.target.dataset.id}`
                    }
                );
            }
        }

        if(e.target.dataset.action == 'cancel_edit' && this.editDialog)
        {
            this.editDialog.close();
        }

        if(e.target.dataset.action == 'create' && this.editDialog)
        {
            this.editDialog.showModal();

            if(Shopify?.CountryProvinceSelector)
            {
                new Shopify.CountryProvinceSelector(
                    `create_address_country`, 
                    `create_address_province`, 
                    {
                        hideElement: `create_address_province_wrapper`
                    }
                );
            }
        }
    }
}

customElements.define('customer-address', CustomerAddress);